import { render } from "./PreviewProduct.vue?vue&type=template&id=3987c204"
import script from "./PreviewProduct.vue?vue&type=script&lang=js"
export * from "./PreviewProduct.vue?vue&type=script&lang=js"

import "./PreviewProduct.vue?vue&type=style&index=0&id=3987c204&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__